import { combineReducers } from 'redux-immutable';
import registerReducer from './register/reducers';

export default combineReducers({
  register: registerReducer,
});
